import { createApiClient, createLocalStorageTokenStore } from '@fsv/shared-client';
import { config } from './config';

const store = createLocalStorageTokenStore();

export const api = createApiClient({
  baseUrl: config.apiBaseUrl,
  store,
  // Read synchronously so the first render is already signed in.
  initialToken: store.peek(),
});
